"use client";

import { useEffect, useState } from "react";

/**
 * Devuelve `value` con un retraso: solo se actualiza cuando pasaron `delayMs` sin
 * nuevos cambios. Sirve para no disparar efectos (p. ej. fetches) en cada pulsación
 * de un input, esperando a que el usuario deje de tipear.
 *
 * @param value  Valor a debouncear.
 * @param delayMs  Ventana de espera en ms (default 400).
 */
const useDebouncedValue = <T>(value: T, delayMs = 400): T => {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
};

export default useDebouncedValue;
